module.exports = __webpack_public_path__ + "img/image14.29d0d99a.jpg";